import { Filter } from './dynamic-filter.model';

export class EquipmentFilter extends Filter {
  cimClass?: number;

  constructor(utilityId?: number, cimClass?: number) {
    super(utilityId);
    this.cimClass = cimClass ?? undefined;
  }
}
